import { render, staticRenderFns } from "./HouseTypeRemarks.vue?vue&type=template&id=2a564034&scoped=true&"
import script from "./HouseTypeRemarks.vue?vue&type=script&lang=js&"
export * from "./HouseTypeRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a564034",
  null
  
)

export default component.exports